import { useState, useEffect } from "react"
import { toast } from "react-toastify"
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  Button as MuiButton,
  Button, 
  Chip,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Snackbar,
  Alert,
  Tooltip
} from "@mui/material"
import * as XLSX from "xlsx"
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  FirstPage,
  LastPage,
  CheckCircle
} from "@mui/icons-material"
import axios from "axios"
import api from "../../components/commonComponents/axiosSetup"
import { useNavigate } from "react-router-dom"
import { BASE_URL } from "../../config"

const TransactionOverview = ({ fileData, fileName, uploadedFile, onSubmit, onPrevious, onCancel, accountName, actionType, category, planType, planId }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage, setRecordsPerPage] = useState(10)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [submitError, setSubmitError] = useState(null)
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState("")
  const [snackbarSeverity, setSnackbarSeverity] = useState("success")
  const [selectedCategory, setSelectedCategory] = useState(category || "")
  console.log(planType, "plantype")
  const kycColumns = [
  { key: "sr_no", label: "SR NO" },
  { key: "iccid", label: "ICCID" },
  { key: "device_imei", label: "DEVICE IMEI" },
  { key: "device_srno", label: "DEVICE SR.NO" },
  { key: "device_make", label: "DEVICE MAKE" },
  { key: "device_model", label: "DEVICE MODEL" },
  {key:"device_type", label:"Device Type"},
  {key:"device_type_other", label:"Device Type Other"},
  { key: "engine_no", label: "ENGINE NO" },
  { key: "chassis_no", label: "CHASSIS NO" },
  { key: "vin_reg_number", label: "VIN/REG NUMBER" },
  { key: "name", label: "NAME" },
  { key: "rmn", label: "RMN" },
  { key: "address", label: "ADDRESS" },
  { key: "proof_of_address_document", label: "PROOF OF ADDRESS DOCUMENT" },
  { key: "proof_of_address_document_no", label: "DOCUMENT NO" },
   { key: "proof_of_identity_document", label: "PROOF OF IDENTITY DOCUMENT" },
  { key: "proof_of_identity_document_no", label: "DOCUMENT NO" }
];
  const navigate = useNavigate();
  // Log received props for debugging
  useEffect(() => {
    console.log("TransactionOverview props received:", { 
      accountName, 
      category, 
      actionType, 
      planType, 
      planId 
    });
  }, [accountName, category, actionType, planType, planId]);
  
  // Update selectedCategory when category prop changes
  useEffect(() => {
    console.log("Category received in TransactionOverview:", category);
    if (category) {
      setSelectedCategory(category);
      console.log("Set selectedCategory to:", category);
    }
  }, [category]);
  
  // Log when selectedCategory changes
  useEffect(() => {
    console.log("selectedCategory changed to:", selectedCategory);
  }, [selectedCategory]);
  
// Replace your validation logic with this:

// Validation functions
const hasSpecialChars = (str) => {
  if (str == null || String(str).trim() === "") return false; // Ignore empty cells
  // Only consider as special chars if it contains letters or symbols (not just numbers)
  return /[a-zA-Z\W_]/.test(String(str).trim());
};

const isValidMsisdnLength = (msisdn) => {
  if (!msisdn) return false;
  const cleanNumber = String(msisdn).trim().replace(/\D/g, '');
  return cleanNumber.length >= 12 && cleanNumber.length <= 15;
};

const isValidMobileNumber = (number) => {
  if (!number) return true; // Skip empty cells
  const cleanNumber = String(number).trim();
  if (cleanNumber === "") return true; // Skip empty strings
  // Check if it contains only digits
  return /^\d+$/.test(cleanNumber);
};

// Find duplicate MSISDNs (case-insensitive, trimmed)
const msisdnCounts = {};
(fileData || []).forEach(row => {
  const msisdn = (row.msisdn || row.Msisdn || "").toString().trim();
  if (msisdn) {
    msisdnCounts[msisdn] = (msisdnCounts[msisdn] || 0) + 1;
  }
});
const duplicateMsisdns = Object.keys(msisdnCounts).filter(msisdn => msisdnCounts[msisdn] > 1);

// Check validations based on category
// const validateRow = (row, category) => {
//   if (!row) return { isValid: true };
  
//   // Common validation for all categories
//   const msisdnValue = row.msisdn || row.Msisdn;
//   if (msisdnValue && !isValidMsisdnLength(msisdnValue)) {
//     return { 
//       isValid: false, 
//       reason: `MSISDN length invalid: should be 12-15 digits (found: ${String(msisdnValue).trim().length}) diigits`
//     };
//   }

//   if (msisdnValue && duplicateMsisdns.includes(String(msisdnValue).trim())) {
//     return {
//       isValid: false,
//       reason: `Duplicate MSISDN found: "${msisdnValue}"`
//     };
//   }
  
//   if (msisdnValue && hasSpecialChars(msisdnValue)) {
//     return { 
//       isValid: false, 
//       reason: `Special characters found in msisdn: "${msisdnValue}"`
//     };
//   }
  
//   if (msisdnValue && !isValidMobileNumber(msisdnValue)) {
//     return {
//       isValid: false,
//       reason: `Invalid mobile number format in msisdn: "${msisdnValue}"`
//     };
//   }
  
//   // Category-specific validations
//   if (category === "Update IMEI") {
//     const imeiValue = row.imei || row.Imei;
//     if (!imeiValue) {
//       return {
//         isValid: false,
//         reason: "IMEI is required"
//       };
//     }
    
//     if (!/^\d+$/.test(String(imeiValue).trim())) {
//       return {
//         isValid: false,
//         reason: `IMEI should contain only digits: "${imeiValue}"`
//       };
//     }
    
//     if (String(imeiValue).trim().length !== 15) {
//       return {
//         isValid: false,
//         reason: `IMEI must be 14 to 16 digits (found: ${String(imeiValue).trim().length})`
//       };
//     }
//   }
  
//   if (category === "Update Device Type") {
//     const deviceType = row.device_type || row.Device_type;
//     if (!deviceType) {
//       return {
//         isValid: false,
//         reason: "Device type is required"
//       };
//     }
//   }
  
//   if (category === "Update SIM Status") {
//     const planName = row.plan_name || row.Plan_name;
//     // if (!planName) {
//     //   return {
//     //     isValid: false,
//     //     reason: "SIM status is required"
//     //   };
//     // }
    
//     // const validStatuses = ["Active", "Inactive", "Suspended", "Terminated"];
//     // if (!validStatuses.includes(String(planName).trim())) {
//     //   return {
//     //     isValid: false,
//     //     reason: `Invalid SIM status. Must be one of: ${validStatuses.join(", ")}`
//     //   };
//     // }
//   }
  
//   return { isValid: true };
// };

// Replace the validateRow function with this updated version:
const validateRow = (row, category) => {
  if (!row) return { isValid: true };
  
  // KYC specific validation
  if (category === "Bulk KYC Verification") {

   const requiredFields = [
  { key: "iccid", label: "ICCID" },
  { key: "device_imei", label: "Device IMEI" },
  { key: "device_srno", label: "Device Serial Number" },
  { key: "device_make", label: "Device Make" },
  { key: "device_model", label: "Device Model" },
  { key:"device_type", label:"Device Type"},
  { key: "engine_no", label: "Engine Number" },
  { key: "chassis_no", label: "Chassis Number" },
  { key: "vin_reg_number", label: "VIN/Registration Number" },
  { key: "name", label: "Name" },
  { key: "rmn", label: "Registered Mobile Number" },
  { key: "address", label: "Address" },
  { key: "proof_of_address_document", label: "Proof of Address Document" },
  { key: "proof_of_address_document_no", label: "Proof of Address Document Number" },
  { key: "proof_of_identity_document", label: "Proof of Identity Document" },
  { key: "proof_of_identity_document_no", label: "Proof of Identity Document Number" }
];

for (const { key, label } of requiredFields) {
  if (!row[key] || String(row[key]).trim() === "") {
    return {
      isValid: false,
      reason: `${label} is required`
    };
  }
}

if (row.device_type?.toLowerCase() === "others") {
  if (!row.device_type_other || String(row.device_type_other).trim() === "") {
    return {
      isValid: false,
      reason: "Device Type Other is required when Device Type is Other"
    };
  }
}
    
    // Validate ICCID format (typically 19-20 digits)
    if (row.iccid && !/^\d{19,20}$/.test(String(row.iccid).trim())) {
      return {
        isValid: false,
        reason: `Invalid ICCID format (should be 19-20 digits)`
      };
    }
    
    // Validate Device IMEI format (15 digits)
    if (row.device_imei && !/^\d{15}$/.test(String(row.device_imei).trim())) {
      return {
        isValid: false,
        reason: `Invalid Device IMEI format (should be 15 digits)`
      };
    }
    
    return { isValid: true };
  }
  
  // Common validation for all other categories
  const msisdnValue = row.msisdn || row.Msisdn;
  if (msisdnValue && !isValidMsisdnLength(msisdnValue)) {
    return { 
      isValid: false, 
      reason: `MSISDN length invalid: should be 12-15 digits (found: ${String(msisdnValue).trim().length}) digits`
    };
  }

  if (msisdnValue && duplicateMsisdns.includes(String(msisdnValue).trim())) {
    return {
      isValid: false,
      reason: `Duplicate MSISDN found: "${msisdnValue}"`
    };
  }
  
  if (msisdnValue && hasSpecialChars(msisdnValue)) {
    return { 
      isValid: false, 
      reason: `Special characters found in msisdn: "${msisdnValue}"`
    };
  }
  
  if (msisdnValue && !isValidMobileNumber(msisdnValue)) {
    return {
      isValid: false,
      reason: `Invalid mobile number format in msisdn: "${msisdnValue}"`
    };
  }
  
  // Category-specific validations for other categories
  if (category === "Update IMEI") {
    const imeiValue = row.imei || row.Imei;
    if (!imeiValue) {
      return {
        isValid: false,
        reason: "IMEI is required"
      };
    }
    
    if (!/^\d+$/.test(String(imeiValue).trim())) {
      return {
        isValid: false,
        reason: `IMEI should contain only digits: "${imeiValue}"`
      };
    }
    
    if (String(imeiValue).trim().length !== 15) {
      return {
        isValid: false,
        reason: `IMEI must be 15 digits (found: ${String(imeiValue).trim().length})`
      };
    }
  }
  
  if (category === "Update Device Type") {
    const deviceType = row.device_type || row.Device_type;
    if (!deviceType) {
      return {
        isValid: false,
        reason: "Device type is required"
      };
    }
  }
  
  return { isValid: true };
};

// Process data with enhanced validations
const processedData = fileData?.map(row => {
  const categoryToUse = selectedCategory || category;
  console.log("Processing row with category:", categoryToUse, row);
  const validation = validateRow(row, categoryToUse);
  
  return {
    ...row,
    status: row.status === "error" ? "error" : (validation.isValid ? "success" : "invalid"),
    invalidReason: row.errorMessage || (validation.isValid ? "" : validation.reason)
  };
})
// Filter based on category
.filter(row => {
  const categoryToUse = selectedCategory || category;
  
  // For KYC verification, filter based on ICCID
  if (categoryToUse === "Bulk KYC Verification") {
    const iccid = row.iccid;
    const hasData = iccid && String(iccid).trim() !== '';
    console.log("KYC row filter:", { iccid, hasData, row });
    return hasData;
  }
  
  // For other categories, filter based on MSISDN
  const msisdn = row.msisdn || row.Msisdn;
  return msisdn && String(msisdn).trim() !== '';
}) || [];

  // Calculate statistics
  const totalRecords = processedData?.length || 0
  const validRecords = processedData?.filter((row) => row.status === "success")?.length || 0
  const invalidRecords = processedData?.filter((row) => row.status === "invalid" || row.status === "error")?.length || 0
  const validRecordsData = processedData?.filter((row) => row.status === "success") || []

  // Pagination logic
  const totalPages = Math.ceil(totalRecords / recordsPerPage)
  const startIndex = (currentPage - 1) * recordsPerPage
  const endIndex = startIndex + recordsPerPage
  const currentData = processedData?.slice(startIndex, endIndex) || []

  const handleSubmitClick = () => {
    setShowConfirmDialog(true)
  }
  
  const handleSnackbarClose = () => {
    setSnackbarOpen(false)
  }
  
  // Function to download invalid records as Excel
  const downloadInvalidRecords = () => {
    // Filter only invalid records
    const invalidRecords = processedData.filter(record => record.status === "invalid" || record.status === "error");
    
    if (invalidRecords.length === 0) {
      setSnackbarMessage("No invalid records to download");
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
      return;
    }
    
    try {
      // Create a new workbook
      const wb = XLSX.utils.book_new();
      
      // Convert the data to a format suitable for Excel, including the invalidReason column
      const dataForExcel = invalidRecords.map(record => {
        const { status, ...recordWithoutStatus } = record;
        return {
          ...recordWithoutStatus,
          invalidReason: record.invalidReason || "Unknown validation error"
        };
      });
      
      // Create a worksheet from the data
      const ws = XLSX.utils.json_to_sheet(dataForExcel);
      
      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, "Invalid Records");
      
      // Generate a download link
      XLSX.writeFile(wb, `invalid_records_${new Date().toISOString().split('T')[0]}.xlsx`);
      
      setSnackbarMessage("Invalid records downloaded successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error downloading invalid records:", error);
      setSnackbarMessage("Failed to download invalid records");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  }

  const handleSubmit = async () => {
    if (!fileData || fileData.length === 0 || !uploadedFile) {
      setSnackbarMessage("No data or file to submit")
      setSnackbarSeverity("error")
      setSnackbarOpen(true)
      toast.error("No data or file to submit")
      return
    }
    
    // Check if there are any invalid records
    const invalidRecordsCount = processedData.filter(record => record.status === "invalid" || record.status === "error").length;
    if (invalidRecordsCount > 0) {
      const errorMessage = `Cannot submit with ${invalidRecordsCount} invalid records. Please fix or remove them.`;
      setSnackbarMessage(errorMessage)
      setSnackbarSeverity("error")
      setSnackbarOpen(true)
      toast.error(errorMessage)
      return
    }
    
    setIsSubmitting(true)
    
    try {
      // Create a FormData object to send the file
      const formData = new FormData()
      
      // Append the file
      formData.append('file', uploadedFile)
      
      // Append other data as JSON
      formData.append('accountName', accountName)
      formData.append('category', selectedCategory || category)
      
      // Only append actionType if it exists (it's optional)
      if (actionType) {
        formData.append('actionType', actionType)
      }

      // Append plan data if available (for SIM activation)
      console.log("Plan data received:", { planType, planId });
      if (planType) {
        formData.append('planName', planType)
        console.log("Added planType to form data:", planType);
      }
      if (planId) {
        formData.append('planId', planId)
        console.log("Added planId to form data:", planId);
      }
      
      // Filter only valid records and add them to the payload
      // formData.append('validRecords', JSON.stringify(validRecordsData))
      
      // Include metadata about the transaction
      const metadata = {
        totalRecords: totalRecords,
        validRecordsCount: validRecords.length,
        fileName: uploadedFile.name,
        uploadTimestamp: new Date().toISOString()
      };
      // formData.append('metadata', JSON.stringify(metadata))
      
      // Log FormData keys for debugging
      console.log("FormData entries:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
      
      // Make the API call 
      // const response = await api.post(
      //   `http://192.168.30.129:9004/bulk/upload`, 
      //   formData,
      //   {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   }
      // )

       // Determine API endpoint based on category
    const categoryToUse = selectedCategory || category;
    let apiUrl;
    
    if (categoryToUse === "Bulk KYC Verification") {
      apiUrl = `${BASE_URL}api/kyc/import`; // Your KYC verification endpoint
      console.log("Using KYC verification API endpoint");
    } else {
      apiUrl = `${BASE_URL}bulk/upload`; 
      // apiUrl = `http://192.168.60.226:7078/bulk/upload`; 
      console.log("Using regular bulk upload API endpoint");
    }
    
    
    // Make the API call with the determined endpoint
    const response = await api.post(
      apiUrl, 
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    )
      
      // Only send valid records to backend - already filtered above
      
      setSubmitSuccess(true)
      setSnackbarMessage(`${validRecords} records submitted successfully`)
      setSnackbarSeverity("success")
      setSnackbarOpen(true)
      
      // Show toast success message
      toast.success(`${validRecords} records submitted successfully`)
      navigate("/bulktransaction")
      
      
      // Call parent onSubmit if provided
      if (typeof onSubmit === 'function') {
        onSubmit({
          success: true,
          message: `${validRecords} records submitted successfully`,
          transactionId: response.data?.transactionId || 'TXN-' + Date.now(),
          recordsProcessed: validRecords
        })
      }
      
    } catch (error) {
      console.error("Error submitting data:", error)
      const errorMessage = error.response?.data?.message || "Failed to submit data";
      setSubmitError(errorMessage)
      setSnackbarMessage(errorMessage)
      setSnackbarSeverity("error")
      setSnackbarOpen(true)
      toast.error(errorMessage)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Box sx={{ p: 2, width: '100%' }}>
      {/* All Status Cards in one row */}
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(5, 1fr)' }, gap: 2, mb: 4 }}>
        {/* File Name */}
        <Paper sx={{ p: 2, border: '1px solid #e0e0e0' }}>
          <Typography variant="body1" sx={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {fileName || "sms_whitelist_sample..."}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            File Name
          </Typography>
        </Paper>

        {/* Success Status */}
        <Card sx={{ 
          backgroundColor: invalidRecords > 0 ? '#ffebee' : '#fff8e1', 
          border: invalidRecords > 0 ? '1px solid #ffcdd2' : '1px solid #ffecc7' 
        }}>
          <CardContent sx={{ p: 2 }}>
            <Typography variant="h6" sx={{ 
              color: invalidRecords > 0 ? '#c62828' : '#b28704', 
              fontWeight: 600 
            }}>
              {invalidRecords > 0 ? 'Warning' : 'Success'}
            </Typography>
            <Typography variant="body2" sx={{ 
              color: invalidRecords > 0 ? '#c62828' : '#b28704' 
            }}>
              {invalidRecords > 0 
                ? `${invalidRecords} invalid records found` 
                : 'Format Validation Status'
              }
            </Typography>
          </CardContent>
        </Card>

        {/* Total Records */}
        <Card sx={{ backgroundColor: '#e3f2fd', border: '1px solid #bbdefb' }}>
          <CardContent sx={{ p: 2 }}>
            <Typography variant="h5" sx={{ color: '#0d47a1', fontWeight: 700 }}>
              {totalRecords}
            </Typography>
            <Typography variant="body2" sx={{ color: '#1976d2' }}>
              Total Records
            </Typography>
          </CardContent>
        </Card>

        {/* Valid Records */}
        <Card sx={{ backgroundColor: '#e3f2fd', border: '1px solid #bbdefb' }}>
          <CardContent sx={{ p: 2 }}>
            <Typography variant="h5" sx={{ color: '#0d47a1', fontWeight: 700 }}>
              {validRecords}
            </Typography>
            <Typography variant="body2" sx={{ color: '#1976d2' }}>
              Valid Records
            </Typography>
          </CardContent>
        </Card>
        
        {/* Invalid Records */}
        <Tooltip title={invalidRecords > 0 ? "Click to download invalid records" : "No invalid records to download"}>
          <Card 
            sx={{ 
              backgroundColor: '#ffebee', 
              border: '1px solid #ffcdd2',
              cursor: invalidRecords > 0 ? 'pointer' : 'default',
              transition: 'all 0.3s',
              '&:hover': {
                boxShadow: invalidRecords > 0 ? '0px 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                transform: invalidRecords > 0 ? 'translateY(-2px)' : 'none',
              }
            }}
            onClick={invalidRecords > 0 ? downloadInvalidRecords : undefined}
          >
            <CardContent sx={{ p: 2 }}>
              <Typography variant="h5" sx={{ color: '#c62828', fontWeight: 700 }}>
                {invalidRecords}
              </Typography>
              <Typography variant="body2" sx={{ color: '#e53935' }}>
                Invalid Records {invalidRecords > 0 && '(click to download)'}
              </Typography>
            </CardContent>
          </Card>
        </Tooltip>
      </Box>

      {/* Basic Info Cards */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>Transaction Details</Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          <Paper sx={{ p: 2, border: '1px solid #e0e0e0', flex: '1 1 250px' }}>
            <Typography variant="body2" color="text.secondary">Account Name</Typography>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>{accountName || "N/A"}</Typography>
          </Paper>
          
          <Paper sx={{ p: 2, border: '1px solid #e0e0e0', flex: '1 1 250px' }}>
            <Typography variant="body2" color="text.secondary">Category</Typography>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>{selectedCategory || category || "N/A"}</Typography>
          </Paper>
          
          <Paper sx={{ p: 2, border: '1px solid #e0e0e0', flex: '1 1 250px' }}>
            <Typography variant="body2" color="text.secondary">Action Type</Typography>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>{actionType || "N/A"}</Typography>
          </Paper>
          
          {planType && (
            <Paper sx={{ p: 2, border: '1px solid #e0e0e0', flex: '1 1 250px' }}>
              <Typography variant="body2" color="text.secondary">Plan</Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {planType} {planId && <span style={{ fontSize: '0.85em', color: '#555' }}>(ID: {planId})</span>}
              </Typography>
            </Paper>
          )}
        </Box>
      </Box>

      {/* Data Table */}
      <Paper sx={{ mb: 3, overflow: 'hidden' }}>
        <Box sx={{ px: 3, py: 2, borderBottom: '1px solid #e0e0e0' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Bulk Transaction Overview
          </Typography>
        </Box>

        <Box sx={{ overflow: 'auto' }}>
          <Table size="small">
<TableHead sx={{ backgroundColor: 'var(--bg)' }}>
  <TableRow>
    {selectedCategory === "Bulk KYC Verification" || category === "Bulk KYC Verification" ? (
      // KYC specific columns
      <>
        {kycColumns.map((col) => (
          <TableCell key={col.key} sx={{ color: 'white', fontWeight: 500 }}>
            {col.label}
          </TableCell>
        ))}
        <TableCell sx={{ color: 'white', fontWeight: 500 }}>Status</TableCell>
        <TableCell sx={{ color: 'white', fontWeight: 500 }}>Issue</TableCell>
      </>
    ) : (
      // Existing columns for other categories
      <>
        <TableCell sx={{ color: 'white', fontWeight: 500 }}>MSISDN</TableCell>
        {selectedCategory === "Update IMEI" && (
          <TableCell sx={{ color: 'white', fontWeight: 500 }}>IMEI</TableCell>
        )}
        {selectedCategory === "Update Device Type" && (
          <TableCell sx={{ color: 'white', fontWeight: 500 }}>Device Type</TableCell>
        )}
        {selectedCategory === "Update SIM Status" && (
          <TableCell sx={{ color: 'white', fontWeight: 500 }}>SIM Status</TableCell>
        )}
        {processedData.length > 0 && Object.keys(processedData[0]).filter(
          key => !['msisdn', 'Msisdn', 'imei', 'Imei', 'device_type', 'Device_type', 'plan_name', 'Plan_name', 'status', 'invalidReason', 'errorMessage'].includes(key)
        ).map(key => (
          <TableCell key={key} sx={{ color: 'white', fontWeight: 500 }}>
            {key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')}
          </TableCell>
        ))}
        <TableCell sx={{ color: 'white', fontWeight: 500 }}>Status</TableCell>
        <TableCell sx={{ color: 'white', fontWeight: 500 }}>Issue</TableCell>
      </>
    )}
  </TableRow>
</TableHead>

<TableBody>
  {currentData.map((row, index) => (
    <TableRow 
      key={index}
      sx={{ 
        backgroundColor: (row.status === "invalid" || row.status === "error")
          ? 'rgba(255, 205, 210, 0.5)'
          : index % 2 === 0 ? 'white' : 'rgba(0, 0, 0, 0.02)',
        '&:hover': {
          backgroundColor: (row.status === "invalid" || row.status === "error")
            ? 'rgba(255, 205, 210, 0.7)'  
            : 'rgba(0, 0, 0, 0.04)',
        }
      }}
    >
      {selectedCategory === "Bulk KYC Verification" || category === "Bulk KYC Verification" ? (
        // KYC specific columns
        <>
          {kycColumns.map((col) => (
            <TableCell key={col.key}>
              {row[col.key] || "-"}
            </TableCell>
          ))}
          <TableCell>
            <Chip 
              label={(row.status === "invalid" || row.status === "error") ? "Invalid" : "Valid"} 
              size="small"
              sx={{ 
                backgroundColor: (row.status === "invalid" || row.status === "error") ? '#ffebee' : '#e8f5e9',
                color: (row.status === "invalid" || row.status === "error") ? '#c62828' : '#2e7d32',
                borderColor: (row.status === "invalid" || row.status === "error") ? '#ffcdd2' : '#c8e6c9'
              }}
            />
          </TableCell>
          <TableCell>
            {(row.status === "invalid" || row.status === "error") && (
              <Tooltip title={row.invalidReason || row.errorMessage || "Invalid record"}>
                <Typography 
                  variant="body2"
                  sx={{ 
                    color: '#c62828',
                    maxWidth: 150,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {row.invalidReason || row.errorMessage || "Invalid record"}
                </Typography>
              </Tooltip>
            )}
          </TableCell>
        </>
      ) : (
        // Existing columns for other categories
        <>
          <TableCell>{row.msisdn || row.Msisdn}</TableCell>
          {selectedCategory === "Update IMEI" && (
            <TableCell>{row.imei || row.Imei || ""}</TableCell>
          )}
          {selectedCategory === "Update Device Type" && (
            <TableCell>{row.device_type || row.Device_type || ""}</TableCell>
          )}
          {selectedCategory === "Update SIM Status" && (
            <TableCell>{row.plan_name || row.Plan_name || ""}</TableCell>
          )}
          {processedData.length > 0 && Object.keys(processedData[0]).filter(
            key => !['msisdn', 'Msisdn', 'imei', 'Imei', 'device_type', 'Device_type', 'plan_name', 'Plan_name', 'status', 'invalidReason', 'errorMessage'].includes(key)
          ).map(key => (
            <TableCell key={key}>{row[key] || ""}</TableCell>
          ))}
          <TableCell>
            <Chip 
              label={(row.status === "invalid" || row.status === "error") ? "Invalid" : "Valid"} 
              size="small"
              sx={{ 
                backgroundColor: (row.status === "invalid" || row.status === "error") ? '#ffebee' : '#e8f5e9',
                color: (row.status === "invalid" || row.status === "error") ? '#c62828' : '#2e7d32',
                borderColor: (row.status === "invalid" || row.status === "error") ? '#ffcdd2' : '#c8e6c9'
              }}
            />
          </TableCell>
          <TableCell>
            {(row.status === "invalid" || row.status === "error") && (
              <Tooltip title={row.invalidReason || row.errorMessage || "Invalid record"}>
                <Typography 
                  variant="body2"
                  sx={{ 
                    color: '#c62828',
                    maxWidth: 150,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {row.invalidReason || row.errorMessage || "Invalid record"}
                </Typography>
              </Tooltip>
            )}
          </TableCell>
        </>
      )}
    </TableRow>
  ))}
</TableBody>
          </Table>
        </Box>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={totalRecords}
          page={currentPage - 1}
          rowsPerPage={recordsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={(e, newPage) => setCurrentPage(newPage + 1)}
          onRowsPerPageChange={(e) => {
            setRecordsPerPage(parseInt(e.target.value, 10));
            setCurrentPage(1);
          }}
          backIconButtonProps={{ size: 'small' }}
          nextIconButtonProps={{ size: 'small' }}
          ActionsComponent={(props) => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <MuiButton 
                size="small" 
                onClick={() => setCurrentPage(1)} 
                disabled={currentPage === 1}
                variant="outlined"
                sx={{ minWidth: 'auto', p: '4px' }}
              >
                <FirstPage fontSize="small" />
              </MuiButton>
              <MuiButton 
                size="small" 
                onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
                variant="outlined"
                sx={{ minWidth: 'auto', p: '4px' }}
              >
                <KeyboardArrowLeft fontSize="small" />
              </MuiButton>
              <MuiButton 
                size="small" 
                onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
                variant="outlined"
                sx={{ minWidth: 'auto', p: '4px' }}
              >
                <KeyboardArrowRight fontSize="small" />
              </MuiButton>
              <MuiButton 
                size="small" 
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
                variant="outlined"
                sx={{ minWidth: 'auto', p: '4px' }}
              >
                <LastPage fontSize="small" />
              </MuiButton>
            </Box>
          )}
        />
      </Paper>

      {/* Action buttons */}
      <Box sx={{ 
        display: "flex", 
        justifyContent: "space-between", 
        mt: 3
      }}>
        <Button
          variant="outlined"
          onClick={onPrevious}
          sx={{
            px: 4,
            textTransform: "none",
            borderColor: "#2D3748",
            color: "#2D3748",
          }}
        >
          Previous Step
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmitClick}
          disabled={isSubmitting}
          sx={{
            px: 4,
            textTransform: "none",
            backgroundColor: "var(--bg)",
            "&:hover": {
              backgroundColor: "var(--bg)",
            },
          }}
        >
          {isSubmitting ? (
            <>
              <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
              Submitting transaction...
            </>
          ) : (
            "Submit Transaction"
          )}
        </Button>
      </Box>

      {/* Confirmation Dialog */}
      <Dialog
        open={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
      >
        <DialogTitle>Confirm Transaction Submission</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to submit {validRecords} valid records from file: {uploadedFile?.name || "Unknown file"}?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Category: {selectedCategory || category || "N/A"}
            {actionType && `, Action Type: ${actionType}`}
            {planType && `, Plan: ${planType}`}
            {planId && ` (ID: ${planId})`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirmDialog(false)}>
            Cancel
          </Button>
          <Button 
            onClick={() => {
              setShowConfirmDialog(false);
              handleSubmit();
            }} 
            variant="contained" 
            color="primary"
          >
            Submit Transaction
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default TransactionOverview
